var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_c('el-alert',{attrs:{"title":_vm.msg,"type":"error","show-icon":"","closable":false}})],1),_vm._v(" "),_c('p',[_c('el-button',{attrs:{"size":"mini","icon":"el-icon-refresh"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('reinit')}}},[_vm._v(_vm._s(_vm.btn))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee2c6252","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/apps/bpm/designer/components/helpers/ReinitWidget.vue
// module id = null
// module chunks = 